import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';

export default {
  title: 'Main Tag values',
  attributeName: 'tags',
  fields: [
    {
      attributeName: 'application',
      helpText: 'Application of the tag',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Aplication',
      placeholder: 'Application...',
      disabled:true
    },
    {
      attributeName: 'type',
      helpText: 'Type of tag',
      type: FormInputTypes.SELECT,
      label: 'Type',
      placeholder: 'Please enter to select a tag type',
      default:'content',
      options: [
        { name: 'Content', value: 'content' },
        { name: 'Room', value: 'room' },
      ],
      disabled:true

    },
    {
      attributeName: 'typeTagAssignment',
      helpText: 'Assignment of the tag',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Assignment',
      placeholder: 'Assignment...',
      disabled:true
    },
    {
      attributeName: 'typeTagName',
      helpText: 'Category of the tag',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Category',
      placeholder: 'Category...',
      disabled:true
    },
    {
      attributeName: 'name',
      helpText: 'Name of the user',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Name',
      placeholder: 'Name...',
      disabled:true
    },
    {
      attributeName: 'description',
      helpText: 'Description of the tag',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Description',
      placeholder: 'Description...',
    },
    {
      attributeName: 'score',
      helpText: 'Score of the tag',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Score',
      placeholder: 'Score...',
    },
    {
      attributeName: 'overwritten',
      label:'Is Customized',
      type: FormInputTypes.LINK,
      icon: IconType.CHECKCIRCLE,
      hasClick:false,
      width: '4rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#1CA733',
      helpText: 'If this is a customized tag.',
      visibleWhen:{"field":"overwritten","value":"yes"},

    },
    {
      attributeName: 'overwritten',
      label:'Is Customized',
      type: FormInputTypes.LINK,
      icon: IconType.CHECKBLANK,
      hasClick:false,
      width: '4rem',
      iconSize:'2x',
      iconColor:'#e9ecef',
      helpText: 'If this is a customized tag.',
      visibleWhen:{"field":"overwritten","value":"no"},

    },   
  ],
};
